import { Theme, Typography } from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { memo } from 'react'
import {
  IConditions,
  INSTALLMENT_BREAK_MAP,
  UNSCHEDULED_REPAYMENT_MAP,
} from './typings'

const useStyles = makeStyles<Theme, { areAllConditionsUnknown: boolean }>(
  (theme: Theme) =>
    createStyles({
      conditionsContainer: {
        display: ({ areAllConditionsUnknown }) =>
          areAllConditionsUnknown ? 'none' : 'flex',
        flexDirection: 'column',
        borderRight: `1px solid ${theme.palette.grey[300]}`,
        height: '100%',
        paddingLeft: 20,
        paddingTop: 20,
        [theme.breakpoints.down('md')]: {
          borderRight: 'none',
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
          margin: '10px 20px',
          paddingLeft: 10,
          paddingTop: 20,
        },
      },
      conditionsContent: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        marginTop: 20,
        gridAutoFlow: 'column',
        [theme.breakpoints.down('md')]: {
          gridAutoFlow: 'row',
          gridTemplateColumns: '1fr',
        },
      },
      checkIcon: {
        color: theme.palette.primary.main,
        fontSize: 24,
        marginRight: 10,
      },
      crossIcon: {
        color: theme.palette.error.main,
        fontSize: 24,
        marginRight: 10,
      },
      headerText: {
        fontWeight: '700',
        fontSize: 18,
        marginTop: 10,
        [theme.breakpoints.down('md')]: {
          marginTop: 20,
        },
      },
      conditionSpanCls: {
        display: 'flex',
        flexDirection: 'row',
      },
      conditionsContainerCls: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 10,
      },
    }),
)

const Conditions = ({ conditions }: IConditions) => {
  const {
    conditionsContainer,
    conditionsContent,
    checkIcon,
    crossIcon,
    headerText,
    conditionSpanCls,
    conditionsContainerCls,
  } = useStyles({
    areAllConditionsUnknown:
      UNSCHEDULED_REPAYMENT_MAP[conditions.unscheduledPartialRepayment] ===
        UNSCHEDULED_REPAYMENT_MAP.unknown &&
      UNSCHEDULED_REPAYMENT_MAP[conditions.unscheduledTotalRepayment] ===
        UNSCHEDULED_REPAYMENT_MAP.unknown &&
      INSTALLMENT_BREAK_MAP[conditions.installmentBreak] ===
        INSTALLMENT_BREAK_MAP.unknown,
  })

  const IS_PARTIAL_REPAYMENT_CHARGABLE =
    UNSCHEDULED_REPAYMENT_MAP[conditions.unscheduledPartialRepayment] ===
    UNSCHEDULED_REPAYMENT_MAP.chargeable

  return (
    <div className={conditionsContainer}>
      <Typography className={headerText}>Ihre Sonderkonditionen</Typography>
      <div className={conditionsContent}>
        {UNSCHEDULED_REPAYMENT_MAP[conditions.unscheduledPartialRepayment] !==
          UNSCHEDULED_REPAYMENT_MAP.unknown && (
          <div className={conditionsContainerCls}>
            <span className={conditionSpanCls}>
              <CheckOutlinedIcon className={checkIcon} />
              <Typography>
                {!IS_PARTIAL_REPAYMENT_CHARGABLE && 'Kostenlose'} Sondertilgung
              </Typography>
            </span>
          </div>
        )}
        {UNSCHEDULED_REPAYMENT_MAP[conditions.unscheduledTotalRepayment] !==
          UNSCHEDULED_REPAYMENT_MAP.unknown && (
          <div className={conditionsContainerCls}>
            <span className={conditionSpanCls}>
              {UNSCHEDULED_REPAYMENT_MAP[
                conditions.unscheduledTotalRepayment
              ] === UNSCHEDULED_REPAYMENT_MAP.free_of_charge ? (
                <CheckOutlinedIcon className={checkIcon} />
              ) : (
                <CloseOutlinedIcon className={crossIcon} />
              )}
              <Typography>Kostenlose Gesamttilgung</Typography>
            </span>
          </div>
        )}
        {INSTALLMENT_BREAK_MAP[conditions.installmentBreak] !==
          INSTALLMENT_BREAK_MAP.unknown && (
          <div className={conditionsContainerCls}>
            <span className={conditionSpanCls}>
              {INSTALLMENT_BREAK_MAP[conditions.installmentBreak] !==
              INSTALLMENT_BREAK_MAP.no_installment_break ? (
                <CheckOutlinedIcon className={checkIcon} />
              ) : (
                <CloseOutlinedIcon className={crossIcon} />
              )}
              <Typography>
                {INSTALLMENT_BREAK_MAP[conditions.installmentBreak] ===
                  INSTALLMENT_BREAK_MAP.free_of_charge && 'Kostenlose'}{' '}
                Ratenpause
              </Typography>
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default memo(Conditions)
